import { faArrowRight as fasArrowRight, faClock as fasClock } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import { AbstractStep } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { ButtonLegacy, FormDecidable, FormSelect } from "@/shared/ui";
import { HAS_EITHER_OF_COUPLE_SOCIAL_INSURANCE } from "./Step2.data";

export interface Step2Fields {
	hasEitherOfCoupleNavDebt: boolean;
	hasEitherOfCoupleSocialInsurance: string;
	isLast180daysSocInHun: boolean;
}

export class Step2 extends AbstractStep<Step2Fields> {
	protected initValues(): Step2Fields {
		return {
			hasEitherOfCoupleNavDebt: undefined,
			hasEitherOfCoupleSocialInsurance: undefined,
			isLast180daysSocInHun: undefined,
		};
	}

	protected renderContent(values: Step2Fields, form: FormApi<Step2Fields>): ReactNode {
		return (
			<>
				<Card.Body>
					<FormDecidable
						label="Van az állami adóhatóságnál köztartozásod? (pl. adótartozás)"
						name="hasEitherOfCoupleNavDebt"
						required
					/>
					<FormSelect
						label="Van jelenleg legalább az egyik félnek maximum 30 napos megszakítással TB jogviszonya (külföldi és magyar kombinálható)?"
						name="hasEitherOfCoupleSocialInsurance"
						placeholder="Kérjük, válassz!"
						prepend={<FontAwesomeIcon icon={fasClock} />}
						options={HAS_EITHER_OF_COUPLE_SOCIAL_INSURANCE}
						infoTooltip="Magyar állampolgár igénylő külföldi társadalom biztosítási (TB) jogosultságot is igazolhat."
						required
					/>
					{values.hasEitherOfCoupleSocialInsurance === "THREE_AND_MORE" && (
						<FormDecidable
							label="Az utolsó 180 nap TB jogviszony magyar alkalmazotti, vállalkozói jogviszonyból származik?"
							name="isLast180daysSocInHun"
							infoTooltip="Amennyiben külföldi TB jogviszonyt igazoltál le, akkor elégséges, ha az utolsó 90 nap származik magyar alkalmazotti, vállalkozói jogviszonyból."
							required
						/>
					)}
				</Card.Body>
				<Card.Footer className="text-center">
					<ButtonLegacy
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
					>
						Tovább
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Step2";
	}
}
